import { Button, Icon, Stack, styled } from '@qcx/ui';
import { ComponentProps } from 'react';
import {
  faFacebookSquare,
  faLinkedin,
  faTelegram,
  faTwitter,
  faWhatsapp
} from '@fortawesome/free-brands-svg-icons';

export type SocialShareButtonProps = ComponentProps<typeof StyledButton>;

interface SocialShareUrlProps {
  url: string;
}

const openSocialShareWindow = (
  url: string,
  provider: string,
  width = 800,
  height = 600
) => {
  if (window?.zaraz) {
    const slugUrl = window?.location?.pathname.match(/(?<=\/n\/)(.*)$/gm);

    if (slugUrl?.length) {
      const [slug] = slugUrl;

      window.zaraz.track('share', {
        method: provider,
        item_id: slug
      });
    }
  }

  window.open(url, '', `width=${width},height=${height}`);
};

export const SocialShareButtons = ({ url }: SocialShareUrlProps) => (
  <Stack css={{ gap: '$4' }}>
    <WhatsappShareButton
      aria-label="Botão para compartilhar no whatsapp"
      rel="noopener noreferrer"
      onClick={() =>
        openSocialShareWindow(
          `https://api.whatsapp.com/send/?text=${url}`,
          'WhatsApp'
        )
      }
    />
    <TelegramShareButton
      aria-label="Botão para compartilhar no telegram"
      rel="noopener noreferrer"
      onClick={() =>
        openSocialShareWindow(
          `https://telegram.me/share/url?url=${url}`,
          'Telegram'
        )
      }
    />
    <FacebookShareButton
      aria-label="Botão para compartilhar no facebook"
      rel="noopener noreferrer"
      onClick={() =>
        openSocialShareWindow(
          `https://www.facebook.com/sharer/sharer.php?u=${url}`,
          'Facebook'
        )
      }
    />
    <TwitterShareButton
      aria-label="Botão para compartilhar no twitter"
      rel="noopener noreferrer"
      onClick={() =>
        openSocialShareWindow(
          `https://twitter.com/intent/tweet?url=${url}`,
          'Twitter'
        )
      }
    />
    <LinkedInShareButton
      aria-label="Botão para compartilhar no linkedin"
      rel="noopener noreferrer"
      onClick={() =>
        openSocialShareWindow(
          `https://www.linkedin.com/shareArticle?url=${url}`,
          'LinkedIn'
        )
      }
    />
  </Stack>
);

export const WhatsappShareButton = (props: SocialShareButtonProps) => (
  <StyledButton
    {...props}
    brand="whatsapp"
    icon={<Icon icon={faWhatsapp} size="lg" />}
    size="lg"
    variant="$neutral100"
  />
);

export const TelegramShareButton = (props: SocialShareButtonProps) => (
  <StyledButton
    {...props}
    brand="telegram"
    icon={<Icon icon={faTelegram} size="lg" />}
    size="lg"
    variant="$neutral100"
  />
);

export const FacebookShareButton = (props: SocialShareButtonProps) => (
  <StyledButton
    {...props}
    brand="facebook"
    icon={<Icon icon={faFacebookSquare} size="lg" />}
    size="lg"
    variant="$neutral100"
  />
);

export const TwitterShareButton = (props: SocialShareButtonProps) => (
  <StyledButton
    {...props}
    brand="twitter"
    icon={<Icon icon={faTwitter} size="lg" />}
    size="lg"
    variant="$neutral100"
  />
);

export const LinkedInShareButton = (props: SocialShareButtonProps) => (
  <StyledButton
    {...props}
    brand="linkedIn"
    icon={<Icon icon={faLinkedin} size="lg" />}
    size="lg"
    variant="$neutral100"
  />
);

const StyledButton = styled(Button, {
  cursor: 'pointer',
  border: 'none',
  flexCenter: true,
  rounded: '$full',
  minMaxSize: 44,
  '&, &:active, &:focus': {
    color: '$text',
    bgColor: '$neutral100'
  },
  '&:hover': {
    color: '$hiContrast'
  },
  variants: {
    brand: {
      facebook: {
        '&:hover': {
          bg: '$blue50 !important',
          color: '$blue800 !important'
        }
      },
      whatsapp: {
        '&:hover': {
          bg: '$blue50 !important',
          color: '$blue800 !important'
        }
      },
      telegram: {
        '&:hover': {
          bg: '$blue50 !important',
          color: '$blue800 !important'
        }
      },
      twitter: {
        '&:hover': {
          bg: '$blue50 !important',
          color: '$blue800 !important'
        }
      },
      linkedIn: {
        '&:hover': {
          bg: '$blue50 !important',
          color: '$blue800 !important'
        }
      }
    }
  }
});
